module.exports = __webpack_public_path__ + "static/media/Photo 2020-04-10, 7 44 12 AM.df1f9746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Photo 2020-04-10, 7 44 12 AM.jpg
// module id = 381
// module chunks = 0